export default __webpack_public_path__ + "static/media/rice.8e58e51a.png";